module.exports = __webpack_public_path__ + "static/img/7.6c8aac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/7.png
// module id = /XCK
// module chunks = 0